export const toCamelCase = (str: string) => {
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const toCamelCaseAll = (str: string) => {
    return str
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const truncateMiddle = (text: string, frontChars: number = 14, backChars: number = 10): string => {
    const maxLength = frontChars + backChars + 1;
    if (!text || text.length <= maxLength) return text;

    return text.slice(0, frontChars) + '....' + text.slice(-backChars);
};
